import React, { useState, useEffect } from 'react';
import T from '../../../components/common/T';
import { useParams, useNavigate } from 'react-router-dom';
import { useUsers } from '../../../context/UserContext';
// import Layout from '../../../components/Layout';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserCircleIcon, EnvelopeIcon, BriefcaseIcon, UserIcon } from '@heroicons/react/24/outline';

// 🟢 SECURITY IMPORT
import { useAuth } from '../../../context/AuthContext';

const ViewUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { users } = useUsers();
  const { checkAccess } = useAuth(); // 🟢 Get Checker

  const [formData, setFormData] = useState(null);

  // 🟢 PAGE GUARD
  useEffect(() => {
    if (!checkAccess('user.view')) {
        toast.error("Access Denied: You do not have permission to view users.");
        navigate('/admin/users');
    }
  }, [checkAccess, navigate]);

  useEffect(() => {
    if(checkAccess('user.view')) {
        const userToView = users.find(u => u.id === parseInt(id));
        if (userToView) {
            setFormData(userToView);
        } else {
            toast.error("User not found");
            navigate('/admin/users');
        }
    }
  }, [id, users, navigate, checkAccess]);

  if (!formData || !checkAccess('user.view')) return null;

  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen font-sans">
        {/* Header */}
        <div className="max-w-4xl mx-auto mb-6 flex justify-between items-center">
          <div className="flex items-center gap-4">
             <h2 className="text-xl font-bold text-gray-800"><T>View User</T></h2>
             <span className="bg-emerald-100 text-emerald-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider"><T>Read Only</T></span>
          </div>
          <span className="text-sm font-mono text-gray-400 bg-gray-100 px-3 py-1 rounded">ID: {id}</span>
        </div>

        <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-lg border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div>
                <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>Full Name</T></label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <UserCircleIcon className="h-5 w-5 text-gray-400" />
                  </div>
                  <input 
                    type="text" 
                    className="w-full pl-10 p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium cursor-not-allowed"
                    value={formData.name}
                    readOnly
                    disabled
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>Username</T></label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <UserIcon className="h-5 w-5 text-gray-400" />
                  </div>
                  <input 
                    type="text" 
                    className="w-full pl-10 p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium cursor-not-allowed"
                    value={formData.username}
                    readOnly
                    disabled
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>Email Address</T></label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <EnvelopeIcon className="h-5 w-5 text-gray-400" />
                  </div>
                  <input 
                    type="text" 
                    className="w-full pl-10 p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium cursor-not-allowed"
                    value={formData.email}
                    readOnly
                    disabled
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>System Role</T></label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <BriefcaseIcon className="h-5 w-5 text-gray-400" />
                  </div>
                  <div className="w-full pl-10 p-3 bg-blue-50 border border-blue-100 rounded-lg text-blue-800 font-bold">
                    {formData.role}
                  </div>
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-500 text-sm font-bold mb-2 uppercase tracking-wide"><T>Account Status</T></label>
                <div className={`p-3 border rounded-lg text-center font-bold ${formData.status === 'Active' ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                    {formData.status}
                </div>
              </div>
            </div>
            <div className="flex justify-end border-t pt-6 mt-2">
              <button 
                onClick={() => navigate('/admin/users')} 
                className="px-8 py-2.5 bg-gray-800 text-white font-bold rounded-lg hover:bg-gray-900 transition shadow-lg"
              >
                &larr; Back to Users
              </button>
            </div>
        </div>
      </div>
    </>
  );
};

export default ViewUser;